import OPEX from './config/OPEX'
import OPEXUGMining from './config/OPEXUGMining'
import OPEXUGMiningDevelopment from './config/OPEXUGMiningDevelopment'
import OPEXUGMiningDevDrilling from './config/OPEXUGMiningDevDrilling'

export default {
  pages : [
    OPEX,
    OPEXUGMining,
    OPEXUGMiningDevelopment,
    OPEXUGMiningDevDrilling
  ]  
}